/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
class CollageSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;

    this.onSectionLoad = this.init.bind(this);
    this.onSectionUnload = this.destroy.bind(this);
  }

  connectedCallback() {
    this.init();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:section:select', this.onSectionLoad);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);
    }
  }

  disconnectedCallback() {
    this.destroy();

    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:section:select', this.onSectionLoad);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
    }
  }

  init(event) {
    if (event && !this.contains(event.target)) return;
    if (this.swiper) return;

    const swiperEl = this.querySelector('[data-swiper]');
    const nextEl = this.querySelector('[data-swiper-next]');
    const prevEl = this.querySelector('[data-swiper-prev]');

    if (!swiperEl || typeof Swiper === 'undefined') return;

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      speed: 600,
      spaceBetween: 48,
      navigation: {
        nextEl,
        prevEl
      },
      observer: true,
      observeParents: true
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('collage-swiper')) {
  customElements.define('collage-swiper', CollageSwiper);
}

/* =========================================================
   Video / Image popup 
   ========================================================= */

(function () {
  if (window.__collagePopupBound) return;
  window.__collagePopupBound = true;

  function openPopup(trigger) {
    const modal = trigger.closest('section')?.querySelector('.collage-video-modal')
      || document.querySelector('.collage-video-modal');

    if (!modal) return;

    const frame = modal.querySelector('.collage-video-frame');
    if (!frame) return;

    const videoSrc = trigger.dataset.videoSrc;
    const imageSrc = trigger.dataset.imageSrc;

    frame.innerHTML = '';

    if (videoSrc) {
      const video = document.createElement('video');
      video.src = videoSrc;
      video.autoplay = true;
      video.controls = true;
      video.playsInline = true;
      video.style.width = '100%';
      video.style.height = '100%';
      video.style.objectFit = 'contain';

      frame.appendChild(video);
    } else if (imageSrc) {
      const img = document.createElement('img');
      img.src = imageSrc;
      img.alt = '';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'contain';

      frame.appendChild(img);
    } else {
      return;
    }

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closePopup(modal) {
    if (!modal) return;

    const frame = modal.querySelector('.collage-video-frame');
    if (frame) frame.innerHTML = '';

    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.collage-video-trigger');
    if (trigger) {
      openPopup(trigger);
      return;
    }

    if (
      e.target.classList.contains('collage-video-overlay') ||
      e.target.classList.contains('collage-video-close')
    ) {
      closePopup(e.target.closest('.collage-video-modal'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.collage-video-modal').forEach(closePopup);
    }
  });

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('.collage-video-modal').forEach(closePopup);
    });
  }
})();
